export const environment = {
  production: true,
  showVersion: false,
  disableGuards: false,
  origin: 'PIBANK',
  api_key: 'SHpIVFE2ZUxEajdMdkNmWFpQaGJTc0tVS19JYTpxcF9qQnZQMzJxel9QanBkZm45ZVU0M1gxcndh',
  api_key_second_holder:
    'TTFTSlZjM3I2aEFQS214MDlNWG83UkhWcUlrYTpzNENaZHE4UW80b3ZDckh1UzhFN0RER2QyM29h',
  key_captcha: '6LeBdnYUAAAAAOBDL3AU9st48owb952VT_A74ASp',
  logout_timeout: 1000 * 60 * 45,

  urlTPV: 'https://sis.redsys.es/sis/realizarPago',

  apiBase: 'https://rest.pibank.es/api',
  apiRevoke: 'https://rest.pibank.es/revoke',
  api_version: {
    mortgages_simulator: '2.12.2',
    toolbox: '6.0.0',
    config_params: '1.3.0',
    i18n: '1.0.1',
    authCore: '1.0.0',
    audit: '1.1.0',
    auth: '1.1.1',
    dashboard: '1.3.0',
    mortgagesDocs: '1.6.1',
    wall: '1.1.0',
    events: '1.2.0',
    tpv: '1.0.0',
  },
};
